import * as React from 'react';

import { LocalizedText } from 'bernie-l10n';

import { DateType } from 'constants/dateType';

import { UitkDatePickerTriggeredSelector } from 'uitk-react-date-picker';

import { CustomTriggerDateFieldWrapper } from 'components/infosite/shared-ui/form/date-field-custom-trigger';
import { StepperButton } from 'components/infosite/rooms-and-rates/stepper-button';

export interface DateStepperProps {
  clickHandler: (event, isTriggeredByStepper) => void;
  endDate: string;
  loadingOffers: boolean;
  startDate: string;
  dateType: DateType;
  buttonText: string;
  invalid: string;
  midnightBookingOffsetHours: number;
  numDaysBookableInAdvance: number;
}

export class DateStepper extends React.Component<DateStepperProps> {
  public render() {
    const defaultStepperClasses = 'uitk-cell all-y-gutter-zero pwa-theme--grey-700 uitk-type-200';

    return (
      <div className={`${defaultStepperClasses} all-cell-1-2`}>
        <DateStepperWrapper {...this.props} />
      </div>
    );
  }
}

const DateStepperWrapper = props => {
  const { dateType } = props;
  let dateStepperLabelKey;
  let stepperButtonLinkName;
  let stepperButtonRfrr;
  let stepperButtonType;
  if (dateType === DateType.CHECK_IN) {
    dateStepperLabelKey = 'hotels.search.form.fromDateHyphen.label';
    stepperButtonLinkName = 'Check-in Date';
    stepperButtonRfrr = ':ChangeDatesCheckIn';
    stepperButtonType = 'CHECK_IN';
  } else if (dateType === DateType.CHECK_OUT) {
    dateStepperLabelKey = 'hotels.search.form.toDateHyphen.label';
    stepperButtonLinkName = 'Check-out Date';
    stepperButtonRfrr = ':ChangeDatesCheckOut';
    stepperButtonType = 'CHECK_OUT';
  }
  const stepperProps = {
    stepperButtonLinkName,
    stepperButtonRfrr,
    stepperButtonType,
    ...props,
  };
  const stepperButtonStyle = 'uitk-cell all-cell-1-6 stepper-button';

  return (
    <React.Fragment>
      <LocalizedText message={dateStepperLabelKey} />
      <div className="uitk-grid all-t-padding-one">
        <div className={`${stepperButtonStyle} all-cell-align-end`}>
          <MinusOneDayStepper {...stepperProps} />
        </div>
        <div className="uitk-cell all-cell-2-3">
          <span className="uitk-type-400 uitk-type-regular" data-stid="content-wizard-checkin">
            <CustomTriggerHelper {...props} />
          </span>
        </div>
        <div className={`${stepperButtonStyle} all-cell-align-start`}>
          <PlusOneDayStepper {...stepperProps} />
        </div>
      </div>
    </React.Fragment>
  );
};

const MinusOneDayStepper = props => {
  const { clickHandler, endDate, loadingOffers, startDate, stepperButtonLinkName, stepperButtonRfrr, stepperButtonType } = props;

  return (
    <StepperButton
      clickHandler={clickHandler}
      endDate={endDate}
      linkName={`${stepperButtonLinkName} Minus One Day`}
      loadingOffers={loadingOffers}
      rfrr={`${stepperButtonRfrr}:MinusOneDay`}
      startDate={startDate}
      stepperType={`${stepperButtonType}_MINUS`}
    />
  );
};

const PlusOneDayStepper = props => {
  const { clickHandler, endDate, loadingOffers, startDate, stepperButtonLinkName, stepperButtonRfrr, stepperButtonType } = props;

  return (
    <StepperButton
      clickHandler={clickHandler}
      endDate={endDate}
      linkName={`${stepperButtonLinkName} Plus One Day`}
      loadingOffers={loadingOffers}
      rfrr={`${stepperButtonRfrr}:PlusOneDay`}
      startDate={startDate}
      stepperType={`${stepperButtonType}_PLUS`}
    />
  );
};

export const CustomTriggerHelper = props => {
  const { clickHandler, dateType, ...dateFieldProps } = props;
  let triggeredSelector;
  let dateFieldRfrr;
  if (dateType === DateType.CHECK_IN) {
    triggeredSelector = UitkDatePickerTriggeredSelector.START;
    dateFieldRfrr = ':ChangeDatesCheckIn';
  } else if (dateType === DateType.CHECK_OUT) {
    triggeredSelector = UitkDatePickerTriggeredSelector.END;
    dateFieldRfrr = ':ChangeDatesCheckOut';
  }

  const commonDateFieldProps = {
    triggeredSelector,
    onChange: clickHandler,
    rfrr: dateFieldRfrr,
    ...dateFieldProps,
  };

  return <CustomTriggerDateFieldWrapper {...commonDateFieldProps} />;
};
